export default __webpack_public_path__ + "static/media/btn-w-gray@3x.4d7feee4.png";